<ng-template #template> Custom and <b>bold</b> </ng-template>

<!-- <div id="header">
  <h1>Playlist: default</h1>
  <p>Development page</p>
</div> -->

<div id="body">
  <div id="container">
    <div id="aspect-box">
      <player></player>
    </div>
    <h1>{{ title() }}</h1>

    <div id="debug">
      @if (username() === null) {
        <p>No user info stored</p>
      } @else {
        <p>Logged in as: {{ username() }}</p>
      }
      <p-button (click)="removeLoggedInUser()" severity="secondary">Remove user info</p-button>
      <p-button severity="secondary" routerLink="/home">Home</p-button>
      <p-button (click)="showToast()" severity="secondary">Send toast demo</p-button>
      <p-button (click)="seekToEnd()" severity="secondary">
        Play next video (seeks current video to end)
      </p-button>
      <p>Current playlist position: {{ playlistPosition() }}</p>
      <input
        type="number"
        #numberInput
        [value]="playlistPosition()"
        style="width: 100px" />
      <p-button
        (click)="setPlaylistPosition(numberInput.valueAsNumber)"
        severity="secondary">
        Set new position
      </p-button>
    </div>
  </div>
  <div id="sidebar">
    <playlist></playlist>
  </div>
</div>
